export const CREATE_DESIGNER = 'CREATE_DESIGNER'
export const UPDATE_DESIGNER = 'UPDATE_DESIGNER'
export const DELETE_DESIGNER = 'DELETE_DESIGNER'
export const GET_DESIGNER_LIST = 'GET_DESIGNER_LIST'
export const GET_DESIGNER_DETAIL = 'GET_DESIGNER_DETAIL'
export const GET_DESIGNER_VERSIONS = 'GET_DESIGNER_VERSIONS'
export const GET_DESIGNER_SPECIFIC_VERSION = 'GET_DESIGNER_SPECIFIC_VERSION'
export const DELETE_DESIGNER_VERSION = 'DELETE_DESIGNER_VERSION'
export const RESTORE_DESIGNER_VERSION = 'RESTORE_DESIGNER_VERSION'
export const GENERATE_STUDENT_ID_CARDS = 'GENERATE_STUDENT_ID_CARDS'
export const GENERATE_FACULTY_ID_CARDS = 'GENERATE_FACULTY_ID_CARDS'
export const GENERATE_CERTIFICATES = 'GENERATE_CERTIFICATES'
export const GENERATE_REPORT_CARDS = 'GENERATE_REPORT_CARDS'
// POST designer/generate — one entry point, `design_type` picks the generator (see
// docs: designer-generate-api). Additive to the per-type routes above.
export const DESIGNER_GENERATE = 'DESIGNER_GENERATE'
export const PREVIEW_REPORT_CARD = 'PREVIEW_REPORT_CARD'
export const CREATE_LIBRARY_FOLDER = 'CREATE_LIBRARY_FOLDER'
export const DELETE_LIBRARY_FOLDER = 'DELETE_LIBRARY_FOLDER'
export const IMPORT_LIBRARY_ASSET = 'IMPORT_LIBRARY_ASSET'
export const GET_LIBRARY_TREE = 'GET_LIBRARY_TREE'
export const CREATE_LIBRARY_COMPONENT = 'CREATE_LIBRARY_COMPONENT'
export const UPDATE_LIBRARY_ITEM = 'UPDATE_LIBRARY_ITEM'
export const GET_LIBRARY_ITEM = 'GET_LIBRARY_ITEM'
